<fieldset>
    <legend>Edit Program {{ programData.name }} </legend>
    <form [formGroup]="programForm" (ngSubmit)="onSubmit()">
        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="name">Name</mat-label>
                <input matInput type="text" formControlName="name" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="shortName">Short Name</mat-label>
                <input matInput type="text" formControlName="shortName" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="description">Description</mat-label>
                <input matInput type="text" formControlName="description" />
            </mat-form-field>

            <div class="control">
                <mat-label for="available" class="available">Available?</mat-label>
                <mat-checkbox formControlName="available" color="primary"></mat-checkbox>
            </div>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="startDate">Start Date</mat-label>
                <input matInput type="date" formControlName="startDate" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="control">
                <mat-label for="endDate">End Date</mat-label>
                <input matInput type="date" formControlName="endDate" />
            </mat-form-field>
        </div>

        <div class="control-row">
            <mat-form-field appearance="outline" class="control">
                <mat-label for="longName">Long Name</mat-label>
                <input matInput type="text" formControlName="longName" />
            </mat-form-field>
        </div>

        <div class="button-row">
            <button type="button" mat-raised-button color="primary" (click)="closeDialog({ isChangeComplete: false })">Cancel</button>
            <button type="submit" mat-raised-button color="primary">Save</button>
        </div>
    </form>
</fieldset>
